(function () {
  'use strict';
  var root = document.querySelector('[data-rvm]');
  if (!root) return;
  var form = root.closest('form');
  if (!form) return;
  function mag(n) { return n === 1 ? 'magnet' : n === 2 ? 'magneta' : n <= 4 ? 'magnete' : 'magnetov'; }
  function fot(n) { return n === 1 ? 'fotografijo' : n === 2 ? 'fotografiji' : n <= 4 ? 'fotografije' : 'fotografij'; }
  var T = {
    addFirst: '+ Dodaj fotografijo',
    addMore: '+ Dodaj še eno fotografijo',
    photo: 'Fotografija',
    qty: 'Količina',
    less: 'Manj',
    more: 'Več',
    remove: 'Odstrani',
    removeAria: function (n) { return 'Odstrani fotografijo ' + n; },
    preparing: 'Fotografija se pripravlja …',
    selected: function (x, y) { return 'Izbrano: ' + x + ' od ' + y + ' ' + (y === 1 ? 'magneta' : 'magnetov'); },
    perfect: 'Odlično – vsi magneti so razporejeni.',
    assign: function (y) { return 'Med svoje fotografije razporedite skupaj ' + y + ' ' + mag(y) + '.'; },
    over: function (n) { return 'Preveč magnetov: odstranite ' + n + ' ' + mag(n) + '.'; },
    tooMany: function (y) { return 'Dodate lahko največ ' + y + ' ' + fot(y) + ' (vsaj 1 magnet na fotografijo).'; },
    heic: 'Vaš brskalnik ne podpira te oblike slike (HEIC/HEIF). Izberite fotografijo JPEG ali PNG.',
    badFile: 'Te datoteke ni bilo mogoče prebrati. Izberite fotografijo JPEG, PNG ali WebP.',
    tooBig: 'Fotografije so skupaj prevelike. Odstranite fotografijo ali izberite manjše.',
    failed: 'Nalaganje ni uspelo. Poskusite znova.',
    pickPack: 'Najprej izberite paket.'
  };
  var MAX_SIDE = 1600;
  var TARGET_BYTES = 470 * 1024;
  var MAX_TOTAL = 10 * 1024 * 1024;
  var MIN_SIDE = 1200;
  var list = root.querySelector('[data-rvm-list]');
  var picker = root.querySelector('[data-rvm-picker]');
  var addBtn = root.querySelector('[data-rvm-add]');
  var statusEl = root.querySelector('[data-rvm-status]');
  var hintEl = root.querySelector('[data-rvm-hint]');
  var errEl = root.querySelector('[data-rvm-error]');
  var busyEl = root.querySelector('[data-rvm-busy]');
  var submitBtn = form.querySelector('[data-cph-add]');
  var idInput = form.querySelector('[data-cph-variant-id]');
  var variantsEl = document.querySelector('script[data-cph-variants]');
  function getVariants() {
    try { return JSON.parse(variantsEl.textContent); } catch (e) { return []; }
  }
  var photos = [];
  var nextId = 1;
  var processing = 0;
  var submitting = false;

  function currentVariant() {
    var id = idInput ? String(idInput.value) : '';
    var variants = getVariants();
    for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) return variants[i]; }
    return null;
  }
  function packSize() {
    var v = currentVariant();
    if (!v) return 0;
    var m = /(\d+)/.exec(v.title || '');
    return m ? parseInt(m[1], 10) : 0;
  }
  function packTitle() {
    var v = currentVariant();
    return v ? v.title : '';
  }
  function variantAvailable() {
    var v = currentVariant();
    return !!(v && v.available);
  }
  function sum() {
    var s = 0;
    photos.forEach(function (p) { s += (p.qty > 0 ? p.qty : 0); });
    return s;
  }
  function totalBytes() {
    var s = 0;
    photos.forEach(function (p) { if (p.blob) s += p.blob.size; });
    return s;
  }
  function isValid() {
    var y = packSize();
    if (!y || !photos.length || processing > 0) return false;
    for (var i = 0; i < photos.length; i++) {
      if (!photos[i].blob || !(photos[i].qty >= 1)) return false;
    }
    return sum() === y;
  }
  function canSubmit() { return isValid() && variantAvailable() && !submitting; }

  function showError(msg) { errEl.textContent = msg; errEl.hidden = false; }
  function clearError() { errEl.textContent = ''; errEl.hidden = true; }

  function apply() {
    if (!submitBtn) return;
    var want = !canSubmit();
    if (submitBtn.disabled !== want) submitBtn.disabled = want;
    submitBtn.setAttribute('aria-busy', submitting ? 'true' : 'false');
  }

  // Photos the customer has not adjusted by hand share what the adjusted ones
  // leave, so the automatic split never exceeds the pack (e.g. 3 photos in a
  // 10-pack become 4 / 3 / 3). Each photo keeps at least one magnet.
  function rebalance() {
    var y = packSize();
    if (!y) return;
    var autos = photos.filter(function (p) { return p.auto; });
    if (!autos.length) return;
    var left = y;
    photos.forEach(function (p) { if (!p.auto) left -= (p.qty > 0 ? p.qty : 0); });
    var base = Math.max(1, Math.floor(left / autos.length));
    var extra = Math.max(0, left - base * autos.length);
    autos.forEach(function (p, i) {
      p.qty = base + (i < extra ? 1 : 0);
      var inp = list.querySelector('input[data-id="' + p.id + '"]');
      if (inp) inp.value = String(p.qty);
    });
  }

  function update() {
    var y = packSize();
    rebalance();
    var x = sum();
    if (!y) {
      statusEl.textContent = T.pickPack;
      hintEl.textContent = '';
      root.classList.remove('is-ok');
    } else {
      statusEl.textContent = T.selected(x, y);
      var ok = isValid();
      hintEl.textContent = ok ? T.perfect : (x > y ? T.over(x - y) : T.assign(y));
      root.classList.toggle('is-ok', ok);
    }
    addBtn.textContent = photos.length ? T.addMore : T.addFirst;
    addBtn.disabled = submitting || !y || (photos.length >= y);
    list.querySelectorAll('input[data-id]').forEach(function (inp) { inp.max = String(y || 1); });
    apply();
  }

  function renderItem(p, index) {
    var li = document.createElement('li');
    li.className = 'rvm__item';
    li.setAttribute('data-item', p.id);
    var img = document.createElement('img');
    img.className = 'rvm__thumb';
    img.alt = T.photo + ' ' + (index + 1);
    if (p.url) img.src = p.url;
    li.appendChild(img);
    var meta = document.createElement('div');
    meta.className = 'rvm__meta';
    var name = document.createElement('span');
    name.className = 'rvm__name';
    name.textContent = T.photo + ' ' + (index + 1);
    meta.appendChild(name);
    if (!p.blob) {
      var prep = document.createElement('span');
      prep.className = 'rvm__prep';
      prep.textContent = T.preparing;
      meta.appendChild(prep);
    }
    li.appendChild(meta);
    var q = document.createElement('div');
    q.className = 'rvm__qty';
    var ql = document.createElement('span');
    ql.className = 'rvm__qlabel';
    ql.textContent = T.qty;
    q.appendChild(ql);
    var ctrl = document.createElement('div');
    ctrl.className = 'rvm__ctrl';
    var dec = document.createElement('button');
    dec.type = 'button'; dec.className = 'rvm__btn'; dec.textContent = '−';
    dec.setAttribute('aria-label', T.less + ' – ' + T.photo + ' ' + (index + 1));
    var inp = document.createElement('input');
    inp.type = 'number'; inp.className = 'rvm__num'; inp.min = '1'; inp.step = '1';
    inp.setAttribute('inputmode', 'numeric');
    inp.setAttribute('data-id', p.id);
    inp.setAttribute('aria-label', T.qty + ' ' + T.photo + ' ' + (index + 1));
    inp.value = String(p.qty);
    var inc = document.createElement('button');
    inc.type = 'button'; inc.className = 'rvm__btn'; inc.textContent = '+';
    inc.setAttribute('aria-label', T.more + ' – ' + T.photo + ' ' + (index + 1));
    ctrl.appendChild(dec); ctrl.appendChild(inp); ctrl.appendChild(inc);
    q.appendChild(ctrl);
    li.appendChild(q);
    var rm = document.createElement('button');
    rm.type = 'button'; rm.className = 'rvm__remove'; rm.textContent = T.remove;
    rm.setAttribute('aria-label', T.removeAria(index + 1));
    li.appendChild(rm);
    var setQty = function (v) { p.qty = v; p.auto = false; inp.value = isNaN(v) ? '' : String(v); update(); };
    dec.addEventListener('click', function () { setQty(Math.max(1, (p.qty || 1) - 1)); });
    inc.addEventListener('click', function () { var y = packSize() || 1; setQty(Math.min(y, (p.qty || 0) + 1)); });
    inp.addEventListener('input', function () { var n = parseInt(inp.value, 10); p.qty = isNaN(n) ? 0 : n; p.auto = false; update(); });
    inp.addEventListener('blur', function () { var y = packSize() || 1; var n = parseInt(inp.value, 10); if (isNaN(n) || n < 1) n = 1; if (n > y) n = y; p.qty = n; inp.value = String(n); update(); });
    rm.addEventListener('click', function () { removePhoto(p.id); });
    return li;
  }
  function render() {
    list.innerHTML = '';
    photos.forEach(function (p, i) { list.appendChild(renderItem(p, i)); });
    update();
  }
  function removePhoto(id) {
    if (submitting) return;
    for (var i = 0; i < photos.length; i++) {
      if (photos[i].id === id) { if (photos[i].url) URL.revokeObjectURL(photos[i].url); photos.splice(i, 1); break; }
    }
    clearError();
    render();
  }

  function decode(file) {
    var viaImage = function () {
      return new Promise(function (res, rej) {
        var img = new Image();
        var u = URL.createObjectURL(file);
        img.onload = function () { URL.revokeObjectURL(u); res(img); };
        img.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
        img.src = u;
      });
    };
    if (window.createImageBitmap) {
      return createImageBitmap(file, { imageOrientation: 'from-image' })
        .catch(function () { return createImageBitmap(file); })
        .catch(viaImage);
    }
    return viaImage();
  }
  function toBlob(canvas, q) {
    return new Promise(function (res) { canvas.toBlob(res, 'image/jpeg', q); });
  }
  async function optimize(file) {
    var src = await decode(file);
    var w = src.naturalWidth || src.width;
    var h = src.naturalHeight || src.height;
    if (!w || !h) throw new Error('decode');
    var scale = Math.min(1, MAX_SIDE / Math.max(w, h));
    var qualities = [0.86, 0.8, 0.74, 0.68, 0.62, 0.56];
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var best = null;
    for (var attempt = 0; attempt < 3; attempt++) {
      var s = scale * Math.pow(0.88, attempt);
      if (attempt > 0 && Math.max(w, h) * s < Math.min(MIN_SIDE, Math.max(w, h))) break;
      canvas.width = Math.max(1, Math.round(w * s));
      canvas.height = Math.max(1, Math.round(h * s));
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(src, 0, 0, canvas.width, canvas.height);
      for (var qi = 0; qi < qualities.length; qi++) {
        var b = await toBlob(canvas, qualities[qi]);
        if (!b) throw new Error('encode');
        best = { blob: b, w: canvas.width, h: canvas.height, q: qualities[qi] };
        if (b.size <= TARGET_BYTES) { if (src.close) src.close(); return best; }
      }
    }
    if (src.close) src.close();
    return best;
  }

  function looksHeic(file) {
    return /\.(heic|heif)$/i.test(file.name || '') || /heic|heif/i.test(file.type || '');
  }
  async function addFiles(files) {
    if (submitting) return;
    clearError();
    var y = packSize();
    if (!y) { showError(T.pickPack); return; }
    var arr = Array.prototype.slice.call(files || []);
    for (var i = 0; i < arr.length; i++) {
      var file = arr[i];
      if (photos.length >= y) { showError(T.tooMany(y)); break; }
      var p = { id: 'p' + (nextId++), qty: 1, auto: true, blob: null, url: null };
      photos.push(p);
      processing++;
      render();
      try {
        var out = await optimize(file);
        p.blob = out.blob;
        p.w = out.w; p.h = out.h; p.q = out.q; p.origBytes = file.size;
        p.url = URL.createObjectURL(out.blob);
      } catch (err) {
        var idx = photos.indexOf(p);
        if (idx > -1) photos.splice(idx, 1);
        showError(looksHeic(file) ? T.heic : T.badFile);
      }
      processing--;
      render();
    }
  }

  function buildFormData() {
    var fd = new FormData(form);
    fd.delete('properties[Paket]');
    fd.set('return_to', '/cart');
    fd.append('properties[Paket]', packTitle());
    photos.forEach(function (p, i) {
      var n = i + 1;
      fd.append('properties[Fotografija ' + n + ']', new File([p.blob], 'foto-' + n + '.jpg', { type: 'image/jpeg' }));
      fd.append('properties[Fotografija ' + n + ' – količina]', String(p.qty));
    });
    return fd;
  }

  function onBeforeUnload(e) { if (submitting) { e.preventDefault(); e.returnValue = ''; } }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (submitting) return;
    if (!isValid() || !variantAvailable()) { update(); return; }
    if (totalBytes() > MAX_TOTAL) { showError(T.tooBig); return; }
    submitting = true;
    clearError();
    busyEl.hidden = false;
    window.addEventListener('beforeunload', onBeforeUnload);
    update();
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 180000);
    try {
      var opts = { method: 'POST', body: buildFormData(), credentials: 'same-origin' };
      if (ctl) opts.signal = ctl.signal;
      var r = await fetch(form.getAttribute('action') || '/cart/add', opts);
      clearTimeout(timer);
      if (!r.ok) throw new Error('http ' + r.status);
      window.removeEventListener('beforeunload', onBeforeUnload);
      window.location.assign('/cart');
    } catch (err) {
      clearTimeout(timer);
      window.removeEventListener('beforeunload', onBeforeUnload);
      submitting = false;
      busyEl.hidden = true;
      showError(T.failed);
      update();
    }
  });

  addBtn.addEventListener('click', function () { if (!addBtn.disabled) picker.click(); });
  picker.addEventListener('change', function () { var f = picker.files; addFiles(f).then(function () { picker.value = ''; }); });
  document.querySelectorAll('[data-cph-input]').forEach(function (i) {
    i.addEventListener('change', function () { Promise.resolve().then(update); setTimeout(update, 0); });
  });
  if (submitBtn && window.MutationObserver) {
    new MutationObserver(function () { apply(); }).observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
  }
  render();
  setTimeout(update, 0);
  window.addEventListener('load', function () { setTimeout(update, 50); });
})();